import DefaultLayout from "@/layouts/DefaultLayout.vue";

export const GuestRoutes = {
    path: "/",
    name: "Home",
    component: DefaultLayout,
    meta: {
        title: "Home - ACASA"
    },
    children: [
        {
            path: "/",
            name: "home",
            component: () => import("@/pages/site/HomePage.vue"),
            meta: {
                title: "Venda e Compra Imobiliária - ACASA"
            }
        },
        {
            path: "/contact",
            name: "contact",
            component: () => import("@/pages/site/ContactPage.vue"),
            meta: {
                title: "Contato - ACASA"
            }
        },
        {
            path: "/request-property",
            name: "request-property",
            component: () => import("@/pages/site/RequestPage.vue"),
            meta: {
                title: "Solicitar Imóvel - ACASA"
            }
        },
        {
            path: '/search',
            name: 'properties',
            component: () => import("@/pages/site/property/HomePage.vue"),
            meta: {
                title: "Buscar Imóvel - ACASA"
            }
        },
        {
            path: '/property/:id',
            name: 'property-details',
            component: () => import("@/pages/site/property/DetailsPage.vue"),
            meta: {
                title: "Detalhes do Imóvel - ACASA"
            }
        },
        {
            path: '/agents',
            name: 'agents',
            component: () => import("@/pages/site/agent/HomePage.vue"),
            meta: {
                title: "Agentes - ACASA"
            }
        },
        {
            path: '/agents/:id',
            name: 'agent-details',
            component: () => import("@/pages/site/agent/DetailsPage.vue"),
            meta: {
                title: 'Produtos do Agente - ACASA'
            }
        },
        {
            path: "/login",
            name: "login",
            component: () => import("@/pages/auth/LoginPage.vue"),
            meta: {
                middleware: "guest",
                title: `Login - ACASA`,
            },
        },

        {
            path: "/forgot-password",
            name: "forgot-password",
            component: () => import("@/pages/auth/RecoverPasswordPage.vue"),
            meta: {
                middleware: "guest",
                title: "Recuperar Senha - ACASA"
            },
        },

        {
            path: '/agente',
            name: "be-agente",
            component: () => import("@/pages/admin/Agents/beAgent.vue"),
            meta: {
                title: 'Ser um Agente - ACASA'
            }
        },
        {
            path: '/franquia',
            name: "franquia",
            component: () => import("@/pages/admin/Agents/franchiseShowForm.vue"),
            meta: {
                title: 'Franquia - ACASA'
            }
        },

        {
            path: "/reset_password/:token",
            name: "recover-password",
            component: () => import("@/pages/auth/NewPasswordPage.vue"),
            meta: {
                middleware: "guest",
                title: "Recuperar Senha - ACASA"
            },
        },
        {
            path: "/register",
            name: "register",
            component: () => import("@/pages/auth/RegisterPage.vue"),
            meta: {
                // middleware: "guest",
                title: `Nova Conta - ACASA`,
            },
        },
        {
            path: "/register-agent",
            name: "register-agent",
            component: () => import("@/pages/auth/RegisterPage.vue"),
            meta: {
                // middleware: "guest",
                title: `Nova Conta - ACASA`,
            },
        },
        {
            path: "/complete-register",
            name: "complete-register",
            component: () => import("@/pages/auth/CompleteProfile.vue"),
            meta: {
                middleware: "guest",
                title: `Nova Conta - ACASA`,
            },
        },
        {
            path: '/profile',
            name: 'profile',
            component: () => import("@/pages/site/profile/MyProfile.vue"),
            requiresAuth: true,
            meta: {
                title: "Perfil - ACASA"
            },
        },

        {
            path: '/update_credetials',
            name: 'update-credentials',
            component: () => import("@/pages/auth/UpdatePasswordPage.vue"),
            meta: {
                title: "Atualizar Credenciais - ACASA"
            }
        },

        {
            path: '/edit-profile',
            name: 'edit-profile',
            component: () => import("@/pages/site/profile/EditProfile.vue"),
            meta: {
                title: 'Editar Perfil - ACASA'
            }
        },
        {
            path: "/about",
            name: "about",
            component: () => import("@/pages/site/AboutPage.vue"),
            meta: {
                title: "Sobre - ACASA"
            }
        },
        {
            path: "/faq",
            name: "faq",
            component: () => import("@/pages/site/FaqPage.vue"),
            meta: {
                title: "FAQ - ACASA"
            }
        },
        {
            path: "/privacy-policy",
            name: "privacy-policy",
            component: () => import("@/pages/site/PrivacyPolicyPage.vue"),
            meta: {
                title: "Política de Privacidade - ACASA"
            }
        },
        {
            path: "/terms-conditions",
            name: "terms-conditions",
            component: () => import("@/pages/site/TermsConditionsPage.vue"),
            meta: {
                title: "Termos e Condições - ACASA"
            }
        }
    ],
};